import React, { useEffect, useState } from "react";
import {
  Pressable,
  StyleSheet,
  View,
  ActivityIndicator,
  Image,
} from "react-native";
import colors from "@constants/color";
import entityStyle from "@utils/entityStyle";
import t from "@constants/localization";
import { getLeaderCustomSkuList } from "@services/api";
import CustomText from "./CustomText";

const ROOT_PATH = "screens/Home/Payment/Registration";

const NonInventoryProductList = (props) => {
  const [fetchingOrderItem, setFetchingOrderItem] = useState(true);
  const [orderItem, setOrderItem] = useState([]);

  useEffect(() => {
    getLeaderCustomSkuList().then(({ data }) => {
      setOrderItem(data.skus);
      setFetchingOrderItem(false);
    });
  }, []);

  const handlePlaceOrder = (orderItem) => {
    props.navigation.navigate("CustomProductDetails", {
      data: orderItem,
      slug: "avyanna-stylish-womens-lemon-green-color-block-printed-khadi-cotton-tunic-size-xl",
    });
  };

  if (fetchingOrderItem) {
    return (
      <View
        style={[
          entityStyle.entityContainer,
          {
            borderRadius: 10,
            overflow: "hidden",
            position: "relative",
            elevation: 1,
            marginBottom: 10,
            backgroundColor: "white",
            paddingVertical: 20,
          },
        ]}
      >
        <ActivityIndicator size="small" color={colors.primary} />
      </View>
    );
  }
  return (
    <View>
      {fetchingOrderItem ? (
        <ActivityIndicator color="#E40046" size="small" />
      ) : (
        orderItem.map((item) => {
          return <RenderCard item={item} handlePlaceOrder={handlePlaceOrder} />;
        })
      )}
    </View>
  );
};

const RenderCard = ({ item: orderItem, handlePlaceOrder = () => {} }) => {
  const image = orderItem.product_images[0];
  const amount = orderItem.mrp;
  const { payable_amount } = orderItem;
  const title = orderItem.product_name_hi;
  const { sku_cta_text } = orderItem;

  return (
    <>
      <View
        style={[
          entityStyle.entityContainer,
          {
            borderRadius: 10,
            overflow: "hidden",
            position: "relative",
            elevation: 1,
            marginBottom: 10,
            marginTop: 8,
            backgroundColor: "white",
          },
        ]}
      >
        <View
          style={{
            backgroundColor: "#fff",
            flexDirection: "row",
            paddingHorizontal: 15,
            padding: 16,
          }}
        >
          <View style={{}}>
            <Image
              source={{ uri: image }}
              style={{
                height: 100,
                width: 100,
              }}
              resizeMode="contain"
            />
          </View>
          <View style={{ flex: 1 }}>
            <>
              <View style={{ paddingHorizontal: 16, paddingTop: 4 }}>
                <CustomText
                  bold
                  fontType="content1"
                  numberOfLines={3}
                  style={{
                    fontSize: 14,
                    lineHeight: 21,
                    color: "rgba(0, 0, 0, 0.86)",
                  }}
                >
                  {title}
                </CustomText>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <CustomText
                    bold
                    fontType="entityHeading"
                    numberOfLines={3}
                    style={{
                      fontWeight: "bold",
                      fontSize: 16,
                      lineHeight: 20,
                      color: "rgba(0, 0, 0, 0.86)",
                      marginRight: 6,
                    }}
                  >
                    ₹{payable_amount}
                  </CustomText>
                  <CustomText
                    bold
                    fontType="content1"
                    numberOfLines={3}
                    style={{
                      fontSize: 12,
                      lineHeight: 16,
                      color: "rgba(0, 0, 0, 0.56)",
                    }}
                  >
                    <CustomText style={{ textDecorationLine: "line-through" }}>
                      ₹{amount}
                    </CustomText>
                    x 1 item
                  </CustomText>
                </View>
              </View>
              <View
                style={{
                  justifyContent: "center",
                  marginTop: 12,
                  borderRadius: 10,
                  paddingHorizontal: 20,
                }}
              >
                <Pressable
                  style={[styles.submitModalButton, { paddingVertical: 6 }]}
                  onPress={() => handlePlaceOrder(orderItem)}
                >
                  <CustomText
                    variant="subtitle_16"
                    style={{
                      color: colors.white,
                      lineHeight: 24,
                      marginBottom: 0,
                      paddingHorizontal: 4,
                    }}
                  >
                    {sku_cta_text}
                  </CustomText>
                </Pressable>
              </View>
            </>
          </View>
        </View>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  modalBackGround: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    width: "90%",
    backgroundColor: "white",
    padding: 20,
    justifyContent: "center",
    alignContent: "center",
    borderRadius: 10,
    elevation: 20,
  },
  submitModalButton: {
    paddingVertical: 12,
    marginBottom: 0,
    backgroundColor: "#E40046",
    borderRadius: 6,
    alignItems: "center",
  },
  submitModalButtonText: {
    color: colors.white,
  },
  submitButton: {
    paddingHorizontal: 42,
    paddingVertical: 12,
    backgroundColor: "#E40046",
    borderRadius: 10,
    minWidth: "75%",
    marginBottom: "33%",
    alignItems: "center",
  },
  submitButtonText: {
    fontFamily: "Mulish-Bold",
    color: "white",
    fontSize: 20,
    lineHeight: 28,
    marginLeft: 8,
  },
  innerContaier: {
    backgroundColor: "#F6EEE9",
    flex: 1,
  },
});

export default NonInventoryProductList;
